/**
 * RolePreview — control compacto para ver Hoy con los ojos de otro rol.
 *
 * Es una MAQUETA: no toca la autenticación, no cambia permisos, no sustituye a
 * ningún guard y no existe fuera de esta vista previa. Sirve para enseñar una
 * idea concreta del producto: quien limpia no necesita ver finanzas ni datos
 * personales del huésped (§14, §15.2).
 *
 * Ocupa una línea. La explicación de qué ve cada rol está en la nota de
 * demostración de la cabecera, no aquí.
 */
import React from "react";
import { ROLE_PREVIEWS } from "@/data/todayV2Demo";

export default function RolePreview({ value, onChange }) {
  return (
    <label
      className="inline-flex items-center gap-1.5 text-[11px] text-stone-400 dark:text-stone-500"
      data-testid="today-role-preview"
    >
      <span>Vista previa como</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="today-role-select"
        aria-label="Vista previa de rol · es una maqueta y no cambia los permisos reales"
        className="dv-input text-xs py-1 pl-2 pr-6 min-h-[44px] max-w-[10rem]"
      >
        {ROLE_PREVIEWS.map((role) => (
          <option key={role.role_key} value={role.role_key}>{role.label}</option>
        ))}
      </select>
    </label>
  );
}
